// ─────────────────────────────────────────────
// components/ErrorBoundary.js
// Catches runtime errors in any child tab/page
// and shows a recovery UI instead of a blank screen.
// License: MIT (your original IP)
// ─────────────────────────────────────────────

import React from "react";
import { NAVY, BLUE, BORDER, STEEL, BRAND_NAME } from "../constants";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Non-fatal — log for operator visibility without crashing
    console.error(`[${BRAND_NAME} ErrorBoundary]`, error, info.componentStack);
  }

  handleReset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const { label = "this section" } = this.props;

    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        textAlign: "center",
      }}>
        <div style={{
          width: 48, height: 48, borderRadius: "50%",
          background: "#fce4e4", display: "flex",
          alignItems: "center", justifyContent: "center",
          fontSize: 22, marginBottom: 16,
        }}>
          ⚠
        </div>
        <div style={{ fontWeight: 700, fontSize: 16, color: NAVY, marginBottom: 6 }}>
          Something went wrong
        </div>
        <div style={{ fontSize: 13, color: STEEL, marginBottom: 24, maxWidth: 280, lineHeight: 1.5 }}>
          There was a problem loading {label}. Your other tabs are unaffected.
        </div>
        <button
          onClick={() => this.handleReset()}
          style={{
            padding: "10px 24px",
            borderRadius: 10,
            border: `1.5px solid ${BORDER}`,
            background: "#fff",
            color: BLUE,
            fontWeight: 700,
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      </div>
    );
  }
}
